import './App.css';
import Router from './AppRouter/AppRouter'
function App() {
  return (
    <div className="App">
      <Router />
    </div>
  );
}

export default App;
